<sgt-select
  [options]="options"
  [settings]="settings"
  [(ngModel)]="selectedId"
  (ngModelChange)="onSelectionChange()"
  (isFirstOpened)="firstOpened()"
>
  <ng-template #customOptionTemplate let-option>
    <span class="concorrente-select__option">
      <i *ngIf="option.icone" class="{{ option.icone }} concorrente-select__icone"></i>
      <img
        *ngIf="option.imagemUrl"
        [src]="option.imagemUrl"
        alt=""
        class="concorrente-select__imagem"
      />
      <span class="concorrente-select__nome">{{ option.label }}</span>
      <span *ngIf="option.tipoLabel" class="concorrente-select__tipo">{{ option.tipoLabel }}</span>
      <span *ngIf="option.inativo" class="concorrente-select__inativo">Inativo</span>
    </span>
  </ng-template>
</sgt-select>
